module.exports = __webpack_public_path__ + "img/violet_062.694c8c1b.png";